/** Minúsculas e sem acento, para "edicao" achar "Edição". */
export const normalizeSearchText = (value: string) =>
  value
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase();

/**
 * Busca na tela, para listas que a API devolve inteiras. `toText` monta o texto da linha (o mesmo que a tabela mostra).
 * Cada palavra digitada precisa aparecer no texto; ignora maiúsculas e acentos. Busca vazia devolve tudo, na mesma ordem.
 */
export function filterBySearch<T>(items: T[], search: string, toText: (item: T) => string[]): T[] {
  const terms = normalizeSearchText(search).split(/\s+/).filter(Boolean);
  if (!terms.length) return items;
  return items.filter((item) => {
    const text = normalizeSearchText(toText(item).join(" "));
    return terms.every((term) => text.includes(term));
  });
}
